export const DOWNLOAD_OPTION_KEYS = Object.freeze({
  playStore: 'playStore',
  sideload: 'sideload',
});

const isHttpUrl = (value) => {
  if (typeof value !== 'string') {
    return false;
  }

  try {
    const url = new URL(value.trim());
    return url.protocol === 'https:' || url.protocol === 'http:';
  } catch {
    return false;
  }
};

export const buildDownloadOptions = (downloads) => {
  const options = [];

  if (isHttpUrl(downloads?.playStoreUrl)) {
    options.push({
      key: DOWNLOAD_OPTION_KEYS.playStore,
      label: 'Google Play Store',
      url: downloads.playStoreUrl.trim(),
      description: 'Escaneie para abrir a loja oficial no dispositivo Android.',
    });
  }

  if (isHttpUrl(downloads?.sideloadUrl)) {
    options.push({
      key: DOWNLOAD_OPTION_KEYS.sideload,
      label: 'Download direto (APK)',
      url: downloads.sideloadUrl.trim(),
      description: 'Escaneie para baixar o APK no dispositivo Android.',
    });
  }

  return options;
};

export const pickPrimaryDownloadOption = (downloads) => {
  const options = buildDownloadOptions(downloads);
  return options.find((option) => option.key === DOWNLOAD_OPTION_KEYS.playStore) ?? options[0] ?? null;
};
